import { useQuery } from '@tanstack/react-query';
import { getQuota } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoicesQuota() {
    const { data, isLoading, error } = useQuery({
        queryKey: ['invoices', 'quota'],
        queryFn: getQuota,
        onError: (error) => trackError(error),
    });

    const percent = data ? Math.min((data.quota_scanned_used / data.quota_scanned_max) * 100, 100) : 0;
    const hasScanningQuota = data ? data.quota_scanned_used < data.quota_scanned_max : false;

    return {
        quota: data,
        isLoading,
        error,
        percent,
        hasScanningQuota
    };
}